module.exports = __webpack_public_path__ + "static/media/end.7639f24e.svg";